import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'sbnb-input-with-slider',
  templateUrl: './input-with-slider.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class InputWithSliderComponent implements OnInit {
  @Input() disabled = false;
  @Input() label = '';
  @Input() fieldValue = 0;
  @Input() controlName: string;

  constructor(public controlContainer: ControlContainer) { }

  ngOnInit(): void { }
}
